export const WebDevelopment = [
    {
      id: 1,
      title: "HTML5",
      img:
        "assets/profile-skills/html5.png",
    },
    {
      id: 2,
      title: "CSS3",
      img:
        "assets/profile-skills/css3.png",
    },
    {
      id: 3,
      title: "Javascript",
      img:
        "assets/profile-skills/js.png",
    },
    {
      id: 4,
      title: "Typescript",
      img:
        "assets/profile-skills/ts.png",
    }
  ];
  
  export const DesignTools = [
    {
      id: 1,
      title: "Figma",
      img: "assets/profile-skills/figma.png",
    }
  ];
  
  export const DevStack = [
    {
      id: 1,
      title: "Web",
      img:
        "assets/profile-skills/web.png",
    },
    {
      id: 2,
      title: "NodeJs",
      img:
        "assets/profile-skills/node-js.png",
    },
    {
      id: 3,
      title: "SQL",
      img:
        "assets/profile-skills/sql.png",
    }
  ];
  
  export const Frameworks = [
    {
      id: 1,
      title: "React JS",
      img:
        "assets/profile-skills/react-native.png",
    },
    {
      id: 2,
      title: "Angular JS 1.x",
      img:
        "assets/profile-skills/ang.png",
    },
    {
      id: 3,
      title: "Angular 2",
      img:
        "assets/profile-skills/ang2.png",
    },
    {
      id: 4,
      title: "Angular Material",
      img:
        "assets/profile-skills/angularmaterial.png",
    },
    {
      id: 5,
      title: "Material UI",
      img:
        "assets/profile-skills/materialUI.png",
    },
    {
      id: 6,
      title: "Bootstrap",
      img:
        "assets/profile-skills/bootstrap.png",
    },
  ];
  
  export const BuildToolsEditor = [
    {
      id: 1,
      title: "Visual Studio Code",
      img:
        "assets/profile-skills/visualstudiocode.png",
    },
    {
      id: 2,
      title: "Git",
      img:
        "assets/profile-skills/git.png",
    },
    {
      id: 3,
      title: "Gulp",
      img:
        "assets/profile-skills/gulp.png",
    },
    {
      id: 4,
      title: "Npm",
      img:
        "assets/profile-skills/npm.png",
    },
    {
      id: 5,
      title: "Bower",
      img:
        "assets/profile-skills/bower.png",
    }
  ];
  